import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PAGINATION_DEFAULT } from 'utils/constants';
import { SCREEN_TYPE } from 'utils/enums';

const initialState: IInventoryPerformanceState = {
    screenMode: SCREEN_TYPE.list,
    formSearch: undefined,
    paginateMetaData: PAGINATION_DEFAULT,
    sort: '',
    keywordSearch: [],
    selectedItem: {
        id: '',
        name: '',
        status: 0,
        responsible_user_id: '',
        planned_date: '',
        done_date: '',
        create_at: '',
        update_at: '',
        comment: '',
    },
};

export const inventoryPerformanceSlice = createSlice({
    name: 'inventoryPerformance',
    initialState,
    reducers: {
        // <> STATE <>
        init: () => initialState,

        // set mode screen: LIST <> DETAIL <> REGISTER (in task page)
        setMode: (state, action: PayloadAction<SCREEN_TYPE>) => {
            state.screenMode = action.payload;
        },
        // set search conditions
        setFormSearch: (state, action: PayloadAction<IInventoryPerformanceSearch | undefined>) => {
            state.formSearch = action.payload;
        },
        // set keywords search conditions
        setKeywordSearch: (state, action: PayloadAction<string[]>) => {
            state.keywordSearch = action.payload;
        },
        // set sort column like "column_name:asc|desc"
        setSort: (state, action: PayloadAction<string>) => {
            state.sort = action.payload;
        },
        // set pagination meta data
        setPaginateMetaData: (state, action: PayloadAction<Pagination>) => {
            state.paginateMetaData = action.payload;
        },
        // set selected item
        setSelectedItem: (state, action: PayloadAction<IInventoryPerformance>) => {
            state.selectedItem = action.payload;
        },
    },
});

export const {
    setSort,
    setPaginateMetaData,
    setMode,
    setFormSearch,
    setKeywordSearch,
    setSelectedItem,
    init,
} = inventoryPerformanceSlice.actions;

export default inventoryPerformanceSlice.reducer;
